/* eslint-disable react/jsx-no-target-blank */
const Footer = () => {
  return (
    <>
      <footer>
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h3 className="text-white">Subscribe Our Newsletter</h3>
              <span>Get the latest news other tips</span>
            </div>
            <div className="col-lg-6">
              <div className="d-flex">
                <input
                  type="text"
                  className="form-control rounded-end-0"
                  style={{ height: 60 }}
                />
                <button className="btn submit-button rounded-start-0 px-4 text-nowrap">
                  Yes I&apos;m In
                </button>
              </div>
            </div>
          </div>
          <div className="border-top my-5 border-light-subtle" />
          <div className="row">
            <div className="col-lg-3 col-md-12">
              <figure className="mb-3">
                <img
                  src="/logo.png"
                  alt="logo"
                  className="img-fluid"
                  style={{ width: 80 }}
                />
              </figure>
              <p className="">
                Staying current and competitive in today&apos;s fast-paced business
                environment takes hard work, but it doesn&apos;t feel that way to us.
                Entrepreneurs ourselves, we thrive on the unprecedented
                challenges and opportunities our
              </p>
              <div className="">
                <button className="btn submit-button">Contact Us</button>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <h4 className="title mb-3 mt-3 mt-lg-0">Address</h4>
              <div className="row">
                <div className="col-lg-6">
                  <h5 className="sub-title mb-3">Our Address</h5>
                  <div className="row">
                    <div className="col-3">
                      <div className="icon-circle">
                        <i className="fa-solid fa-location-dot text-white" />
                      </div>
                    </div>
                    <div className="col-9">
                      <div className="address-heading ms-2">
                        <p>
                          <a
                            href="https://goo.gl/maps/HP6TN2d6dx4rCY7L6"
                            target="_blank"
                            className="text-white text-decoration-none"
                          >
                            Edmonds
                            <br />
                            <span>
                              123 2nd Ave S, Ste 230
                              <br />
                              Edmonds, WA 98020
                            </span>
                          </a>
                        </p>
                        <p>
                          <a
                            href="https://www.google.com/maps/place/3600+136th+Pl+SE+Suite+300,+Bellevue,+WA+98006,+USA/@47.5786532,-122.1542795,17z/data=!3m1!4b1!4m6!3m5!1s0x54906ea89d71653b:0x4503db983a7289b4!8m2!3d47.5786532!4d-122.1542795!16s%2Fg%2F11mx6y78fl?entry=ttu"
                            target="_blank"
                            className="text-white text-decoration-none"
                          >
                            Bellevue <br />
                            <span>
                              3600 136th Pl SE #300 <br />
                              Bellevue, WA 98006
                            </span>
                          </a>
                        </p>
                        <p>
                          <a
                            href="https://www.google.com/maps/place/2818+N+Sullivan+Rd+Suite+100,+Spokane+Valley,+WA+99216,+USA/@47.683193,-117.194393,17z/data=!3m1!4b1!4m6!3m5!1s0x5361dfc3bcb72241:0x4363a26fd854a9c9!8m2!3d47.683193!4d-117.194393!16s%2Fg%2F11nssjnkc5?entry=ttu"
                            target="_blank"
                            className="text-white text-decoration-none"
                          >
                            Spokane <br />
                            <span>
                              2818 N. Sullivan Rd., Suite 100 Spokane <br />
                              Valley, WA 99216
                            </span>
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <h5 className="sub-title mb-3">Customer Help</h5>
                  <div className="row mt-2 d-flex align-items-center">
                    <div className="col-3">
                      <div className="icon-circle">
                        <i className="fa-solid fa-phone-volume text-white" />
                      </div>
                    </div>
                    <div className="col-9">
                      <div className="address-heading ms-2">
                        <p className="m-0">
                          <span>206-408-8111 (o)</span>
                          <br />
                          <span>206-374-2351 (f)</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-4 d-flex align-items-center">
                    <h5 className="sub-title my-2">Customer Email</h5>
                    <div className="col-3">
                      <div className="icon-circle">
                        <i className="fa-solid fa-envelope text-white" />
                      </div>
                    </div>
                    <div className="col-9">
                      <div className="address-heading ms-2">
                        <p className="m-0">
                          <a
                            href="mailto:info@foundrylawgroup.com"
                            target="_blank"
                            className="text-decoration-none"
                          >
                            info@foundrylawgroup.com
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-md-6 col-sm-12">
              <h4 className="title mb-3 ms-4 mt-3 mt-lg-0">Explore Link</h4>
              <div className="ms-4 address-heading">
                <a href="https://foundrylawgroup.com/about/" className="text-decoration-none d-block mb-2">
                  About
                </a>
                <a href="https://foundrylawgroup.com/team/" className="text-decoration-none d-block mb-2">
                  Team
                </a>
                <a href="https://foundrylawgroup.com/services/" className="text-decoration-none d-block mb-2">
                  Services
                </a>
                <a href="https://foundrylawgroup.com/pricing/" className="text-decoration-none d-block mb-2">
                  Pricing
                </a>
                <a href="https://foundrylawgroup.com/community/" className="text-decoration-none d-block mb-2">
                  Community
                </a>
                <a href="https://foundrylawgroup.com/blog/" className="text-decoration-none d-block mb-2">
                  Foundry Law Blog
                </a>
                <a href="https://foundrylawgroup.com/contact/" className="text-decoration-none d-block mb-2">
                  Contact Us
                </a>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12">
              <h4 className="title mb-3 mt-3 mt-lg-0">Explore Link</h4>
              <div className="row">
                <div className="col-lg-4">
                  <figure>
                    <img src="/base3.jpg" alt="" />
                  </figure>
                </div>
                <div className="col-lg-8">
                  <span>October 23, 2023</span>
                  <p>
                    Which Entities Are Subject to FinCEN&apos;s New Reporting Rules?
                  </p>
                </div>
                <div className="border-top my-3" />
                <div className="col-lg-4">
                  <figure>
                    <img src="/base1.png" alt="" />
                  </figure>
                </div>
                <div className="col-lg-8">
                  <span>October 16, 2023</span>
                  <p>FinCEN Issues New Beneficial Ownership Reporting Rules</p>
                </div>
              </div>
            </div>
          </div>
          <div className="border-top my-5 border-light-subtle" />
          <div className="row">
            <div className="col-lg-7 col-md-4 text-white">
              <div className="footer-section d-flex align-items-center">
                <h2 className="footer-subtitle text-white mb-0 me-2">
                  Follow Social
                </h2>
                <div className="mx-lg-3 mx-1 me-1 icon-circle">
                  <a href="https://www.linkedin.com/company/foundry-law-group" target="_blank"><i className="fa-brands fa-linkedin-in text-dark" /></a>
                </div>
                <div className="icon-circle">
                  <a href="https://twitter.com/FoundryLaw" target="_blank"><i className="fa-brands fa-x-twitter text-dark" /></a>
                </div>
              </div>
              
            </div>
            <div className="col-lg-5 text-lg-end col-md-8">
               <p className="ms-2 text-white ">
                  ©2024 Foundry Law Group. All Rights Reserved.
                </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
